import Vue from 'vue'
import qs from 'qs'
import api from '../../src/api/api.js'

const that = this
// noinspection JSAnnotator
export default {
  axiosSuccessFun: function (bean, response) { // bean{this,fail,url,failBack,callBack}
    let me = bean.this
    let _that = this
    if (me.$refs.toastCompo) {
      me.$refs.toastCompo.clear()
    } else if (me.$parent.$refs.toastCompo) {
      me.$parent.$refs.toastCompo.clear()
    } else if (me.$parent.$parent.$refs.toastCompo) {
      me.$parent.$parent.$refs.toastCompo.clear()
    }
    if (bean.fail !== false) { // 控制是否有后台的弹窗
      bean.fail = true
    }
    if (response.flag) {
      if (bean.callBack) {
        bean.callBack(response)
      }
    } else {
      if (response.hasOwnProperty('data') && response.data.hasOwnProperty('mobileRedirect')) { // 接口返回重定向字段
        window.location.href = response.data.mobileRedirect
      } else {
        if (bean.fail) {
          if (response.msg) {
            if (response.msg == '没有登录') {
              _that.delCookieSync('loginUser')
              me.$parent.$refs.alertCompo.setProps({
                singleBtn: false,
                alertTitle: window.vm.$i18n.t('dc_lang.温馨提示'),
                sureTxt: window.vm.$i18n.t('dc_lang.去登录'),
                cancelTxt: window.vm.$i18n.t('dc_lang.好的'),
                alertMessage: window.vm.$i18n.t('dc_lang.没有登录'),
                sureFun: () => {
                  let goSrc = ''
                  if (bean.url) {
                    goSrc = window.location.origin + '' + bean.url
                  }
                  let url = that.a.ssoUrl(goSrc)
                  window.location.href = url
                  // me.$router.push('/login?redirect=' + bean.url)  //url 为跳转到登录页面之前页面的path和query
                }
              })
            } else {
              if (me.$parent.$refs.alertCompo) {
                me.$parent.$refs.alertCompo.setProps({
                  singleBtn: true,
                  alertMessage: response.msg
                })
              } else if (me.$parent.$parent.$refs.alertCompo) {
                me.$parent.$parent.$refs.alertCompo.setProps({
                  singleBtn: true,
                  alertMessage: response.msg
                })
              }

              if (bean.failBack) {
                bean.failBack(response)
                return null
              }
            }
          }
        }
        if (bean.failBack) {
          bean.failBack(response)
        }
      }
    }
  },
  axiosFailFun: function (bean, error) {
    let me = bean.this
    if (me.$refs.toastCompo) {
      me.$refs.toastCompo.clear()
    } else if (me.$parent.$refs.toastCompo) {
      me.$parent.$refs.toastCompo.clear()
    } else if (me.$parent.$parent.$refs.toastCompo) {
      me.$parent.$parent.$refs.toastCompo.clear()
    }
    if (error.response) {
      switch (error.response.status) {
        case 400:
          error.message = '请求错误(400)'
          break
        case 401:
          error.message = '未授权，请重新登录(401)'
          break
        case 403:
          error.message = '拒绝访问(403)'
          break
        case 404:
          error.message = '请求出错(404)'
          break
        case 408:
          error.message = '请求超时(408)'
          break
        case 500:
          error.message = '服务器错误(500)'
          break
        case 501:
          error.message = '服务未实现(501)'
          break
        case 502:
          error.message = '网络错误(502)'
          break
        case 503:
          error.message = '服务不可用(503)'
          break
        case 504:
          error.message = '网络超时(504)'
          break
        case 505:
          error.message = 'HTTP版本不受支持(505)'
          break
        default:
          error.message = `连接出错(${error.response.status})!`
      }

      if (me.$parent.$refs.alertCompo) {
        me.$parent.$refs.alertCompo.setProps({
          singleBtn: true,
          alertMessage: error.message
        })
      } else if (me.$parent.$parent.$refs.alertCompo) {
        me.$parent.$parent.$refs.alertCompo.setProps({
          singleBtn: true,
          alertMessage: error.message
        })
      }
    }
  },
  checkLogin (bean) {
    const me = this
    if (bean.this.$parent.checkLoginStatusAjaxFun) {
      bean.this.$parent.checkLoginStatusAjaxFun(() => {
        me.checkLoginFun(bean)
      })
    } else if (bean.this.$parent.$parent.checkLoginStatusAjaxFun) {
      bean.this.$parent.$parent.checkLoginStatusAjaxFun(() => {
        me.checkLoginFun(bean)
      })
    }
  },
  checkLoginFun (bean) {
    const me = this
    let loginUser = JSON.parse(this.getCookieSync('loginUser'))
    if (loginUser && loginUser.loginStatus) {
      if (bean.callBack) {
        bean.callBack()
      }
    } else {
      let goSrc = ''
      if (bean.url) {
        goSrc = window.location.origin + '' + bean.url
      }
      let url = me.ssoUrl(goSrc)
      window.location.href = url
      // bean.this.$router.push({path: '/login', query: {redirect: bean.url}})
    }
  },
  getCookie: (cname) => {
    const name = cname + '='
    const ca = document.cookie.split(';')
      console.log(ca)
    for (let i = 0; i < ca.length; i++) {
      const c = ca[i].trim()
      if (c.indexOf(name) === 0) {
        return c.substring(name.length, c.length)
      }
    }
    return ''
  },
  setCookie: (key, value) => {
    document.cookie = key + '=' + value + ';path=/;'
  },
  addCookieSync: function (key, value) {
    window.localStorage.setItem(key, value)
  },
  getCookieSync: function (key) {
    return window.localStorage.getItem(key)
  },
  delCookieSync: function (key) {
    window.localStorage.removeItem(key)
  },
  format: function (time, format, type) {
    if (time !== '' && time !== null) {
      time = Number(time) ? Number(time) : time
      var t = new Date(time)
      var tf = function (i) {
        return (i < 10 ? '0' : '') + i
      }
      return format.replace(/yyyy|MM|dd|HH|mm|ss/g, function (a) {
        switch (a) {
          case 'yyyy':
            return tf(t.getFullYear())
          case 'MM':
            return tf(t.getMonth() + 1)
          case 'mm':
            return tf(t.getMinutes())
          case 'dd':
            return tf(t.getDate())
          case 'HH':
            return tf(t.getHours())
          case 'ss':
            return tf(t.getSeconds())
        }
      })
    } else {
      var emptys = '--'
      if (type === 'empty') {
        return ''
      } else {
        return emptys
      }
    }
  },
  ossAddr: function (str) {
    return 'https://pu-datacastle.oss-cn-qingdao.aliyuncs.com/master.third.source/cmptmini' + str
  },
  defaultAvatar: function (str, id) {
    if (str) {
      return str
    } else {
      return 'https://www.dcjingsai.com/common/allow/defaultAvatar.image?id=' + id
    }
  },
  split: function (str, sym, index) {
    var i = '' + str
    return str == '' ? [] : i.split(sym)[index]
  },
  mathRound: function (data) {
    return Math.round(data)
  },
  ceil: function (data) {
    return Math.ceil(data)
  },
  errorImg: function (id) {
    id = id || 0
    let num = (id % 10) + 1
    if (num > 7 || !num) {
      num = 1
    }
    // return 'this.src=' + '"https://pu-datacastle.oss-cn-qingdao.aliyuncs.com/master.third.source/other_new/jingsai/avatar/' + num + '.png"';
    return 'https://pu-datacastle.oss-cn-qingdao.aliyuncs.com/master.third.source/other_new/jingsai/avatar/' + num + '.png'
  },
  // 处理项目列表主图加载错误
  bindOwnImg: function (_errId) {
    if (!_errId) return
    let num = _errId.toString().slice(_errId.toString().length - 1, _errId.toString().length)
    return 'https://pu-datacastle.oss-cn-qingdao.aliyuncs.com/master.third.source/cmptmini/img/listbanner/' + num + '.jpg'
  },
  // 处理无项目图片的id
  formItemId: function (id) {
    var idStr = id.toString()
    return idStr.slice(idStr.length - 1, idStr.length)
  },
  deleteEmpty (bean) { // 删除对象中的空或者null值的属性
    for (var i in bean) {
      if (bean[i] == '' || bean[i] === null) {
        delete bean[i]
      }
    }
    return bean
  },
  jsonpFun (url) {
    var jsonp = document.createElement('script')
    jsonp.type = 'text/javascript'
    jsonp.src = url
    document.getElementsByTagName('head')[0].appendChild(jsonp)

    window.appId = '1s3maw5r'
    window.requestCookie = document.cookie
    window.redirect = window.location.href
  },
  ssoUrl (goUrl) {
    let redirect = goUrl || window.location.href
    redirect = encodeURIComponent(redirect)
    let url = '' // ssologin
      console.log(process.env.NODE_ENV );
      // url = 'http://sso.dc.com/login.html?appId=1s3maw5r&redirect=' + redirect
    if (process.env.NODE_ENV == 'test' || process.env.NODE_ENV == 'development') {
      url = 'http://sso.dc.com/login.html?appId=1s3maw5r&redirect=' + redirect
    } else {
      url = 'https://sso.datacastle.cn/login.html?appId=1s3maw5r&redirect=' + redirect
    }
    return url
  }
}



//////////////////
// WEBPACK FOOTER
// ./static/js/common.js
// module id = /sA3
// module chunks = 55